export default "__VITE_ASSET__DgNUD4mk__"